import React, { useState } from "react";
import "./ssefaq.css";

function SSEFaqQ() {
    // Track which FAQ is open (by index)
    const [activeIndex, setActiveIndex] = useState(0);

    // FAQ questions and answers
    const faqs = [
        {
            question: "Can you help me?",
            answer: "Send us an email or call us and we can assist with the Education program."
        },
        {
            question: "How long will it take?",
            answer: "SSE Class is for 1 Hour every week."
        },
        {
            question: "How much will it cost?",
            answer: "FREE !!! Education is a gift from Bhagawan Sri Sathya Sai Baba and is provided at no cost."
        },
        {
            question: "Can i have more information?",
            answer: <> SSE program from Sri Sathya Sai International Organization is available <a href="https://sathyasai.us/education" target="_blank" rel="noreferrer">here.</a> </>
        },
        {
            question: "Can I become a SSE Teacher?",
            answer: <>Yes. You can read more <a href="https://sathyasai.us/education-tt" target="_blank" rel="noreferrer">here.</a></>
        }
    ];

    return (
        <section id="faq-254">
            <div className="cs-container">
                <div className="cs-content">
                    <span className="cs-topper">SSE</span>
                    <h2 className="cs-title">Sai Spiritual Education Questions</h2>
                    <p className="cs-text">
                        Here are some of the most common questions we get asked about the Sai Spiritual Education (SSE) program.
                    </p>
                </div>
                <div className="cs-flex-group">
                    <ul className="cs-faq-group">
                        {faqs.map((faq, idx) => (
                            <li
                                className={`cs-faq-item${activeIndex === idx ? " active" : ""}`}
                                key={idx}
                            >
                                <button
                                    className="cs-button"
                                    onClick={() => setActiveIndex(activeIndex === idx ? -1 : idx)}
                                >
                                    {faq.question}
                                </button>
                                {activeIndex === idx && (
                                    <p className="cs-item-p">{faq.answer}</p>
                                )}
                            </li>
                        ))}
                    </ul>
                    <div className="cs-cta">
                        <h3 className="cs-h3">Don't see the answer you need?</h3>
                        <p className="cs-cta-p">
                            SaiRam. That's ok. Just drop a message or call us and we will get back to you ASAP.
                        </p>
                        <a href="/contact" className="cs-button-solid">Contact us</a>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default SSEFaqQ;